// Flux
import { TypedAction } from "@ms/uno-fluxcore/lib/local/actions/Action";
import { ActionType } from "../ActionType";
/**
 * Action to set the default plan (plan where tasks are created when a plan is not specified explicitly).
 */ export class SetDefaultPlanAction extends TypedAction(ActionType.SetDefaultPlanAction) {
    loggingData() {
        return {
            value: this.value,
            source: this.source
        };
    }
    constructor(value, source){
        super(), this.value = value, this.source = source;
    }
}
export class ClearDefaultPlanAction extends TypedAction(ActionType.ClearDefaultPlanAction) {
    loggingData() {
        return {
            source: this.source
        };
    }
    constructor(source){
        super(), this.source = source;
    }
}
/**
 * Action to set the flagged email plan (plan where flagged emails based tasks are created).
 */ export class SetFlaggedEmailPlanAction extends TypedAction(ActionType.SetFlaggedEmailPlanAction) {
    loggingData() {
        return {
            value: this.value
        };
    }
    constructor(value){
        super(), this.value = value;
    }
}
